import React from 'react';
import Routes from '../routes/routes';
import ErrorBoundary from './errorBoundary/ErrorBoundary';

function App() {

	if (process.env.NODE_ENV === 'development') {
  const observer = new MutationObserver(() => {
    const overlay = document.querySelector('iframe#webpack-dev-server-client-overlay');
    if (overlay) overlay.remove();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

	return (
		<React.StrictMode>
			<ErrorBoundary>
				<Routes />
			</ErrorBoundary>
		</React.StrictMode>
	);
};

export default App;